<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 mb-2">
        <div class="row align-items-center text-center">
          <div class="col-12 text-center">
            <button v-b-modal.create-pattern class="btn iconed btn-secondary"><i
              class="icon-bd-plus"></i><span>جدید</span></button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 p-0">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="text-center">عملیات</th>
            <th scope="col" class="text-center">ردیف</th>
            <th scope="col" class="text-center">کد</th>
            <th scope="col" class="text-center">عنوان فعالیت</th>
            <th scope="col" class="text-center">توضیحات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in personsActivity">
            <td class="text-center">
              <!--<button :id="'btn-precondition-' + item.id" class="btn btn-secondary ml-2"
                      :class="{'btn-warning': patternDecoration === 'suspend'}"
                      @click="createPatternDecoration(item, index)"
                      data-toggle="tooltip" title="مشخص کردن روابط بین کارگاه ها"><i class="icon-content-duplicate"></i>
              </button>
              <button :id="'btn-delete-' + item.id" v-b-modal.delete-pattern class="btn btn-secondary"
                      :class="{'btn-danger': deleteButtonState === 'suspend'}" @click="onDeleteClicked(item, index)"><i
                class="icon-bd-delete"></i></button>-->
            </td>
            <td class="text-center">{{index + 1}}</td>
            <td class="text-center">{{item.code}}</td>
            <td class="text-center">{{item.title}}</td>
            <td class="text-center">{{item.description}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <!--<div class="col-12">
        <b-pagination
          align="center"
          @input="onPersonPaginationChange"
          :total-rows="rows"
          :per-page="pagination.pageSize"
        ></b-pagination>
      </div>-->

      <b-modal
        ref="persons"
        id="create-persons"
        size="lg"
        title="ایجاد شخص جدید"
        ok-title="ذخیره"
        cancel-title="لغو"
        @cancel="hideModal"
        @ok=""
      >

      </b-modal>


    </div>

  </div>
</template>

<script>
    import PatternDependencies from "../components/PatternDependencies"
    import VsSelect from "../_framework/VsSelect";
    import BaseService from "../_framework/api/BaseService.js";
    import Vue from "vue";
    import Utils from "../_framework/utils/Utils.js";
    import * as $ from 'jquery';

    export default {
        name: "product-patterns",
        props: {},
        components: {
            VsSelect,
            PatternDependencies
        },
        data() {
            return {
                footerBgVariant: 'light',
                bodyBgVariant: 'light',
                headerBgVariant: 'danger',
                headerTextVariant: 'white',
                pagination: {
                    pageIndex: 0,
                    pageSize: 12,
                },
                personsActivity: [],
                deleteButtonState: "primary",
                patternDecoration: 'deactive',
            }
        },
        mounted() {
            this.getPersonsActivityDetail();


        },
        methods: {
            getPersonsActivityDetail() {
                new BaseService('PersonActivityTypes', '/GetPaging').getList().then((response) => {
                        // console.log(response.data);
                        this.personsActivity = response.data;
                    }
                ).catch((error) => {
                    console.log(error)
                });
            },
            onPersonPaginationChange() {

            },


            hideModal() {
            },
        },
        computed: {
            /*rows() {
                return this.pageCount.count
            }*/
        },
        watch: {}
    }
    ;
</script>
